import { defineComponent as _defineComponent } from 'vue'
import store from '@/store';
import { dispatchDeleteUserSearchCriteria } from '@/store/main/actionsMain';
import {
  readAssertedCompanyId,
  readAssertedUserProfile,
} from '@/store/main/getters';
import { ref, watch } from 'vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteMyFilterDialog',
  props: {
    value: { type: Boolean },
    searchCriteriaId: null
  },
  emits: ["input", "deleted"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'deleted'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  searchCriteriaId: string;
};

const m = defineMessages({
  modalTitle: 'マイフィルターを削除しますか？',
});




const localValue = ref(props.value);

watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  }
);

const isLoading = ref(false);

const closeDialog = () => {
  if (isLoading.value) {
    return;
  }

  localValue.value = false;
  emits('input', false);
};

const handleDeleteClick = async () => {
  isLoading.value = true;
  try {
    await dispatchDeleteUserSearchCriteria(store, {
      userId: readAssertedUserProfile(store).uuid,
      companyId: readAssertedCompanyId(store),
      searchCriteriaId: props.searchCriteriaId,
    });
    isLoading.value = false;
    closeDialog();
    emits('deleted');
  } catch (e) {
    isLoading.value = false;
  }
};

const handleCancelClick = () => {
  closeDialog();
};

return { __sfc: true,m, props, emits, localValue, isLoading, closeDialog, handleDeleteClick, handleCancelClick, BaseFormCard, sharedMessages }
}

})